import { useState } from "react";
import { Button } from "@/components/ui/button";
import CustomerMultiSelect from "@/components/salgsmuligheter/agents/CustomerMultiSelect";
import { useRunSignalAgentsNow } from "@/hooks/use-run-signal-agents";

/** Admin: kjør agentene mot én valgt kunde nå. Koster penger, og krever CRM_AGENTS_ENABLED på serveren. */
export function RunAgentsNowPanel() {
  const [selected, setSelected] = useState<string[]>([]);
  const run = useRunSignalAgentsNow();
  const customerId = selected[0];

  return (
    <section className="space-y-3" aria-label="Kjør agenter nå">
      <div>
        <h3 className="text-sm font-medium">Kjør agenter nå for kunde…</h3>
        <p className="text-sm text-muted-foreground">
          Kjører alle aktive agenter mot én kunde med en gang. Signalene lagres, og kostnaden regnes med i oversikten over.
        </p>
      </div>
      <CustomerMultiSelect value={selected} onChange={(ids) => setSelected(ids.slice(-1))} />
      <Button disabled={!customerId || run.isPending} onClick={() => customerId && run.mutate(customerId)}>
        {run.isPending ? "Kjører …" : "Kjør agentene"}
      </Button>
    </section>
  );
}
